import { z } from 'zod';

/**
 * Phase 2: Reviewers as first-class. Backed by `flow_review_reviewers`
 * (migration 048). A review row carries an explicit reviewer list;
 * approval gating counts only the `required` reviewers.
 */

export const FlowReviewerRoleSchema = z.enum(['required', 'optional']);
export type FlowReviewerRole = z.infer<typeof FlowReviewerRoleSchema>;

export const FlowReviewReviewerSchema = z.object({
  reviewId: z.string().uuid(),
  userId: z.string().uuid(),
  userName: z.string(),
  /** User's avatar URL (or null when not set). */
  avatarUrl: z.string().nullable().optional(),
  role: FlowReviewerRoleSchema,
  invitedBy: z.string().uuid().nullable(),
  invitedByName: z.string().nullable(),
  invitedAt: z.string(),
  /** Set when removed; UI can render the row greyed out for context. */
  removedAt: z.string().nullable(),
  /**
   * Convenience field combining the latest decision (if any) with
   * stale_at — saves an extra join in the UI banner.
   */
  latestDecision: z.enum(['approved', 'changes_requested', 'pending']),
  decisionStale: z.boolean(),
});
export type FlowReviewReviewer = z.infer<typeof FlowReviewReviewerSchema>;

export const AddReviewerBodySchema = z.object({
  userId: z.string().uuid(),
  role: FlowReviewerRoleSchema.default('required'),
});
export type AddReviewerBody = z.infer<typeof AddReviewerBodySchema>;

export const ReRequestReviewerBodySchema = z.object({}).strict();
export type ReRequestReviewerBody = z.infer<typeof ReRequestReviewerBodySchema>;

export const ListReviewersResponseSchema = z.object({
  reviewers: z.array(FlowReviewReviewerSchema),
});
export type ListReviewersResponse = z.infer<typeof ListReviewersResponseSchema>;
